import React from 'react';
import { useEditor } from '@craftjs/core';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';

export * from './ToolbarItem';
export * from './ToolbarSection';
export * from './ToolbarTextInput';
export * from './ToolbarDropdown';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1, 0),
    height: '100%',
  },
  placeholder: {
    padding: theme.spacing(2, 2.5),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: '11px',
  },
  placeholderTitle: {
    padding: theme.spacing(0, 1),
    marginBottom: theme.spacing(1),
  },
}));

export const Toolbar = () => {
  const classes = useStyles();
  const { active, related } = useEditor((state, query) => {
    const currentlySelectedNodeId = query.getEvent('selected').first();
    return {
      active: currentlySelectedNodeId,
      related:
        currentlySelectedNodeId && state.nodes[currentlySelectedNodeId].related,
    };
  });

  return (
    <Box className={classes.root}>
      {active && related?.toolbar && React.createElement(related.toolbar, { nodeId: active })} 
      {!active && (
        <div className={classes.placeholder}>
          <Typography variant="body2" className={classes.placeholderTitle}>
            Haz clic en un componente para empezar a editarlo.
          </Typography>
          <Typography variant="body2">
            También puedes hacer doble clic en las capas de abajo para editar sus nombres.
          </Typography>
        </div>
      )}
    </Box>
  );
};